import { render, staticRenderFns } from "./ExpreDetail.vue?vue&type=template&id=2b50e8bf&scoped=true"
import script from "./ExpreDetail.vue?vue&type=script&lang=js"
export * from "./ExpreDetail.vue?vue&type=script&lang=js"
import style0 from "./ExpreDetail.vue?vue&type=style&index=0&id=2b50e8bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50e8bf",
  null
  
)

export default component.exports